import { RecordedData } from "../types";
import dayjs from "dayjs";
import { encodeWav } from "./wav";

export function generateVoiceFileData(
  allRecordedData: RecordedData[],
  recordingScene: string,
): FormData {
  const formData = new FormData();
  const now = dayjs().format("YYYY.MM.DD.HH.mm.ss");
  for (
    let phraseIndex = 0;
    phraseIndex < allRecordedData.length;
    ++phraseIndex
  ) {
    const recorded = allRecordedData[phraseIndex];
    if (!recorded.isSkipped) {
      const wav = encodeWav(recorded.data, recorded.samplingRate) as Blob;
      const phrase = phraseIndex.toString().padStart(2, "0");
      formData.append("files", wav, `${phrase}_${now}.wav`);
      if (recorded.co1VoiceType) {
        formData.append("cog_voice_types", recorded.co1VoiceType);
      }
      if (recorded.phrase) {
        formData.append("phrases", recorded.phrase);
      }
    }
  }
  if (recordingScene) {
    formData.append("recording_scene", recordingScene);
  }
  return formData;
}
